import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@trillion/ui/components/ui/button";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { NetworkForm } from "@/components/networks/network-form";
import { adminApi } from "@/lib/admin-api";
import { describeApiError } from "@/lib/api-error";
import type { ProductSource } from "@/types";

export function NetworkNewPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(data: Partial<ProductSource>) {
    setIsLoading(true);
    try {
      await adminApi.sources.create(data);
      toast.success("Network created successfully");
      navigate("/networks");
    } catch (err) {
      toast.error("Failed to create network", {
        description: describeApiError(err),
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <PageHeader
        title="New Network"
        description="Add a new affiliate network"
        actions={
          <Button variant="outline" onClick={() => navigate("/networks")}>
            <ArrowLeft className="mr-2 size-4" />
            Back to Networks
          </Button>
        }
      />
      <NetworkForm onSubmit={handleSubmit} isLoading={isLoading} />
    </div>
  );
}
